<template>
  <div class="time-picker">
    <div class="date-box">
      <div class="date-header">
        <van-nav-bar
          :title="dateRange"
          :left-arrow="dateSwipeIndex > 0"
          @click-left="dateSwipeTo(0)"
          @click-right="dateSwipeTo(1)"
        >
          <van-icon name="arrow" v-if="dateSwipeIndex < 1" slot="right" />
        </van-nav-bar>
      </div>
      <van-swipe
        ref="dateSwipe"
        :show-indicators="false"
        @change="getDateRange"
        :loop="loop"
      >
        <van-swipe-item v-for="(item, index) in dateData" :key="index">
          <div class="week">
            <van-grid :column-num="7" :border="false">
              <van-grid-item v-for="date in item" :key="date.date">
                <div class="text">
                  {{ week[getWeek(date.workDate)] }}
                  <p class="desc">{{ date.day }}</p>
                </div>
              </van-grid-item>
            </van-grid>
          </div>
          <div class="date">
            <van-grid :column-num="7">
              <van-grid-item
                v-for="(date, index) in item"
                :key="index"
                :class="{
                  disabled: !date.detail[0].ifWork,
                  selected:
                    date.workDate === active.date && active.type === 'AM'
                }"
                :clickable="true"
                @click="dateClick(date, 'AM')"
              >
                <div class="text">上午</div>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="7">
              <van-grid-item
                v-for="(date, index) in item"
                :key="index"
                :class="{
                  disabled: !date.detail[1].ifWork,
                  selected:
                    date.workDate === active.date && active.type === 'PM'
                }"
                :clickable="true"
                @click="dateClick(date, 'PM')"
              >
                <div class="text">下午</div>
              </van-grid-item>
            </van-grid>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Grid, GridItem, NavBar, Icon } from "vant";
import chunk from "lodash/chunk";
import { getWeek } from "@/utils/common";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "TimeCardPicker",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: String,
      default: ""
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      week: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      dateData: [],
      dateRange: "",
      dateSwipeIndex: 0,
      active: {
        date: "",
        type: ""
      }
    };
  },
  model: {
    prop: "value",
    event: "update"
  },
  watch: {
    data() {
      this.copyData();
    }
  },
  created() {
    // this.copyData();
    // if (this.copyData && this.copyData.length) {
    //   this.dateData = this.getData();
    //   // this.getDateRange(0);
    //   }
  },
  methods: {
    getWeek,
    copyData() {
      this.copyData = cloneDeep(this.data);
      console.log(this.copyData);

      this.dateData = this.getData();
      this.getDateRange(0);
    },
    getData() {
      const data = this.copyData.map(item => {
        const dateArr = item.workDate.split("-");
        const day = dateArr[1] + "-" + dateArr[2];
        item.day = day;
        return item;
      });
      const dateData = chunk(data, 7);
      return dateData;
    },

    dateClick(date, type) {
      const index = type === "AM" ? 0 : 1;
      if (!date.detail[index].ifWork) return;
      this.active = { date: date.workDate, type: type };
      this.$emit("change", this.active);
    },
    getDateRange(index) {
      this.dateSwipeIndex = index;
      const arr = this.dateData[index];
      console.log(arr);

      this.dateRange = arr[0].day + " - " + arr[6].day;
    },
    dateSwipeTo(index) {
      this.$refs.dateSwipe.swipeTo(index);
    }
  }
};
</script>

<style lang="less" scoped>
// .time-picker {
//   .date-box {
//     .van-grid-item__content {
//       padding: 0.4rem 0.26667rem;
//     }
//   }
// }
</style>
